export const Woo = (function () {
	'use strict';

	let wooShippingAddress, wooGForm15;

	function init() {

		wooShippingAddress = document.querySelector('#shipping_address_1_field');

		if (wooShippingAddress) {
			// console.log('te', wooShippingAddress);
			let wooShippingAddressLabel = wooShippingAddress.querySelector('label');
			wooShippingAddressLabel.innerHTML += 'Test';
		}

		productQuantity();
		upsCollectAccountNumberDisplay();

		$(document).on('gform_post_render', function(event, formId){
			wooShippingAddress = document.querySelector('#shipping_address_1_field');
			if (wooShippingAddress) { 
				let wooShippingAddressLabel = wooShippingAddress.querySelector('label');
				wooShippingAddressLabel.innerHTML += 'Test';
			}

			if(formId == 15) { // Machining Form
				wooGForm15 = document.querySelector('.add-to-cart-options #gform_15');
				renderStandardMachiningForm();
			}
		});

		$(document).on('facetwp-loaded', function () {
			productTooltips();
		});
	}

	function renderStandardMachiningForm() {
		document.getElementsByClassName('add-to-cart-options')[0].classList.add('standard-machining-form');
	};

	function productQuantity() {
		// Increment/Decrement for Product Quantity
		if (document.querySelector('.product .quantity')) {
			var productQuantity = document.querySelector('.product .quantity');
			var productQuantityInput = document.querySelector('.product .qty');
			var decrementButtonHTML = '<button type="button" class="product__quantity__dec">–</button>';
			var incrementButtonHTML = '<button type="button" class="product__quantity__inc">+</button>';

			$(productQuantity).prepend(decrementButtonHTML).append(incrementButtonHTML);

			var decrementButtonEl = document.querySelector('.product__quantity__dec');
			var incrementButtonEl = document.querySelector('.product__quantity__inc');

			decrementButtonEl.addEventListener('click', function () {
				if (productQuantityInput.value > 0) {
					productQuantityInput.value = parseInt(productQuantityInput.value, 10) - 1;
				}
			});

			incrementButtonEl.addEventListener('click', function () {
				productQuantityInput.value = parseInt(productQuantityInput.value, 10) + 1;
			});
		}
	};

	function upsCollectAccountNumberDisplay() {
		$(document.body).on('updated_checkout', function () {
			var upsCollectMethodInput = document.getElementById('shipping_method_0_je_ups_collect');
			var upsCollectAccountWrap = document.getElementById('ups-account-number_field');
			var enableUPSCollect = document.getElementById('enable-ups-collect');

			// if (enableUPSCollect.checked) {
			// 	upsCollectAccountWrap.classList.add('show');
			// } else {
			// 	upsCollectAccountWrap.classList.remove('show');
			// }

			// Code stuffs
			enableUPSCollect.addEventListener('click', function () {
				if (enableUPSCollect.checked) {
					upsCollectAccountWrap.classList.add('show');
				} else {
					upsCollectAccountWrap.classList.remove('show');
				}
			});
		});
	};

	function productTooltips() {
		var tooltipLinks = document.querySelectorAll('.product-loop__tooltip-link');
		var tooltips = document.querySelectorAll('.product-loop__tooltip');

		tooltipLinks.forEach(function (link) {
			link.addEventListener('click', function (event) {
				var productFooter = link.closest('.product-loop__footer');
				var productTooltip = productFooter.querySelector('.product-loop__tooltip');
				event.stopPropagation();

				tooltips.forEach(function (tooltip) {
					if (tooltip !== productTooltip) {
						tooltip.classList.remove('show');
					}
				});

				productTooltip.classList.toggle('show');
			});
		});

	};

	return {
		init: init,
	};
})();
